import { render, staticRenderFns } from "./ChangeLogoButton.vue?vue&type=template&id=0983ba3d&"
import script from "./ChangeLogoButton.vue?vue&type=script&lang=js&"
export * from "./ChangeLogoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0983ba3d')) {
      api.createRecord('0983ba3d', component.options)
    } else {
      api.reload('0983ba3d', component.options)
    }
    module.hot.accept("./ChangeLogoButton.vue?vue&type=template&id=0983ba3d&", function () {
      api.rerender('0983ba3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeLogoButton.vue"
export default component.exports